const isCurrencyCode = (value?: string | null): value is string => {
  return typeof value === 'string' && /^[A-Za-z]{3}$/.test(value);
};

export const formatAffiliateAmount = (
  amount?: number | null,
  currency?: string | null
) => {
  if (typeof amount !== 'number') {
    return '—';
  }

  const normalizedCurrency = isCurrencyCode(currency)
    ? currency.toUpperCase()
    : undefined;

  if (normalizedCurrency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: normalizedCurrency,
      }).format(amount);
    } catch {
      return `${amount.toLocaleString()} ${normalizedCurrency}`;
    }
  }

  return `${amount.toLocaleString()} ₽`;
};
